import React from 'react';
import CookieConsent from "react-cookie-consent";

class UnderConstruction extends React.Component {

    componentDidMount() { }


    render() {
        var logo = <div class='logoWeb'>
            <img src="./assets/logo192.png" alt="Logo" class='logoImageLeft'></img>
            <img src="./assets/logo_wide.png" alt="Augenstern" id="headerlogo" class='logoImageCenter'></img>
            <img src="./assets/logo192.png" alt="Logo" class='logoImageRight'></img>
        </div >

        return (
            <div id="contentcontainer" class='fullwidth fullheight floatrelative'>
                <div class='topmenuWeb floatrelative'>
                    {logo}
                </div>
                <div>
                    <div class='underconstruction'>
                        Diese Seite befindet sich aktuell im Umbau. Wir bitten Sie um etwas Geduld!
                    </div>
                </div>
                <CookieConsent
                    location="bottom"
                    buttonText="Akzeptieren"
                    cookieName="AugensternCookieConsent"
                    style={{ background: "#000000", fontSize: "20px", fontFamily: "Garamond" }}
                    buttonStyle={{ background: "#737373", color: "#FFFFFF", fontSize: "20px" }}
                    expires={1}
                    debug={false}
                    overlay={true}
                >
                    Wir verwenden Cookies um die Benutzerfreundlichkeit zu verbessern. Bitte akzeptieren Sie um die Seite besuchen zu können!{" "}
                </CookieConsent>
            </div >
        );
    }
}


export default (UnderConstruction);